import React, { useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlay, FaImage, FaNewspaper, FaDownload, FaExternalLinkAlt, FaCalendar, FaCamera, FaVideo, FaChevronDown, FaEye, FaHeart, FaShare } from 'react-icons/fa';

// Animation variants
const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: "easeOut" }
    }
};

const fadeInLeft = {
    hidden: { opacity: 0, x: -60 },
    visible: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.6, ease: "easeOut" }
    }
};

const fadeInRight = {
    hidden: { opacity: 0, x: 60 },
    visible: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.6, ease: "easeOut" }
    }
};

const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.15,
            delayChildren: 0.1
        }
    }
};

const scaleIn = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: { duration: 0.5, ease: "easeOut" }
    }
};

const slideInFromBottom = {
    hidden: { opacity: 0, y: 50 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: "easeOut" }
    }
};

const MediaPage = () => {
    const [activeTab, setActiveTab] = useState('photos');

    const photoGallery = [
        {
            id: 1,
            image: "/images/IMG-20250605-WA0398.jpg",
            title: "Education Program",
            description: "Children participating in our education initiative",
            category: "Education",
            views: "245",
            likes: "32"
        },
        {
            id: 2,
            image: "/images/IMG-20250605-WA0399.jpg",
            title: "Community Learning",
            description: "Quality education being provided to underprivileged children",
            category: "Education",
            views: "187",
            likes: "28"
        },
        {
            id: 3,
            image: "/images/IMG-20250605-WA0400.jpg",
            title: "Classroom Activities",
            description: "Interactive learning sessions with children",
            category: "Education",
            views: "156",
            likes: "21"
        },
        {
            id: 4,
            image: "/images/IMG-20250605-WA0402.jpg",
            title: "Health Camp",
            description: "Free health checkup and awareness program",
            category: "Health",
            views: "298",
            likes: "45"
        },
        {
            id: 5,
            image: "/images/IMG-20250605-WA0396.jpg",
            title: "Community Gathering",
            description: "Community members participating in awareness program",
            category: "Community",
            views: "321",
            likes: "52"
        },
        {
            id: 6,
            image: "/images/IMG-20250605-WA0394.jpg",
            title: "Educational Support",
            description: "Providing educational materials to children",
            category: "Education",
            views: "213",
            likes: "35"
        },
        {
            id: 7,
            image: "/images/IMG-20250605-WA0389.jpg",
            title: "Vocational Training",
            description: "Skills development program for women and youth",
            category: "Training",
            views: "178",
            likes: "26"
        },
        {
            id: 8,
            image: "/images/IMG-20250605-WA0383.jpg",
            title: "Child Development",
            description: "Personality development session with children",
            category: "Development",
            views: "234",
            likes: "41"
        },
        {
            id: 9,
            image: "/images/IMG-20250605-WA0378.jpg",
            title: "Self-Defence Training",
            description: "Empowering youth with self-defence skills",
            category: "Training",
            views: "289",
            likes: "38"
        },
        {
            id: 10,
            image: "/images/IMG-20250605-WA0375.jpg",
            title: "Achievement Recognition",
            description: "Celebrating children's achievements and progress",
            category: "Achievements",
            views: "165",
            likes: "29"
        },
        {
            id: 11,
            image: "/images/IMG-20250605-WA0372.jpg",
            title: "Women Empowerment",
            description: "Women participating in self-help group activities",
            category: "Empowerment",
            views: "267",
            likes: "44"
        },
        {
            id: 12,
            image: "/images/IMG-20250605-WA0377.jpg",
            title: "Community Activities",
            description: "Building stronger communities through engagement",
            category: "Community",
            views: "195",
            likes: "33"
        }
    ];

    const mediaNews = [
        {
            id: 1,
            type: "News Article",
            title: "Ummeed Ki Kiran Foundation Trust: Lighting Hope in Varanasi Slums",
            source: "Local Community Newsletter",
            date: "March 2024",
            description: "Feature story highlighting our 8 years of educational work in Varanasi slums and community impact",
            readTime: "5 min read",
            featured: true,
            link: "#"
        },
        {
            id: 2,
            type: "Feature Story",
            title: "Education as Empowerment: UKKFT's Impact on Children",
            source: "NGO Quarterly Magazine",
            date: "January 2024",
            description: "In-depth coverage of our educational programs and their impact on decision-making capacity",
            readTime: "8 min read",
            featured: false,
            link: "#"
        },
        {
            id: 3,
            type: "Press Release",
            title: "UKKFT Celebrates 8 Years of Service to Underprivileged Children",
            source: "Foundation Press Release",
            date: "December 2023",
            description: "Milestone celebration highlighting achievements since 2016",
            readTime: "3 min read",
            featured: false,
            link: "#"
        },
        {
            id: 4,
            type: "Community Coverage",
            title: "Local NGO Making Difference in Child Education",
            source: "Varanasi Community News",
            date: "November 2023",
            description: "Recognition of our work by local community leaders and impact assessment",
            readTime: "6 min read",
            featured: false,
            link: "#"
        }
    ];

    const videos = [
        {
            id: 1,
            thumbnail: "/images/IMG-20250605-WA0401.jpg",
            title: "Education Program Overview",
            duration: "3:45",
            description: "A comprehensive look at our education initiatives in Varanasi slums",
            category: "Documentary",
            views: "1.2K",
            uploadDate: "2 weeks ago"
        },
        {
            id: 2,
            thumbnail: "/images/IMG-20250605-WA0403.jpg",
            title: "Health Camp Success Story",
            duration: "2:30",
            description: "Highlights from our free health camp and awareness programs",
            category: "Health",
            views: "856",
            uploadDate: "1 month ago"
        },
        {
            id: 3,
            thumbnail: "/images/IMG-20250605-WA0389.jpg",
            title: "Vocational Training Impact",
            duration: "4:15",
            description: "Stories of women and youth empowered through our training programs",
            category: "Training",
            views: "743",
            uploadDate: "3 weeks ago"
        },
        {
            id: 4,
            thumbnail: "/images/IMG-20250605-WA0383.jpg",
            title: "Children Development Journey",
            duration: "5:20",
            description: "Showcasing personality development and recreational activities",
            category: "Development",
            views: "1.5K",
            uploadDate: "1 week ago"
        }
    ];

    const categories = ['All', 'Education', 'Health', 'Training', 'Community', 'Development', 'Empowerment', 'Achievements'];
    const [selectedCategory, setSelectedCategory] = useState('All');

    const filteredPhotos = selectedCategory === 'All'
        ? photoGallery
        : photoGallery.filter(photo => photo.category === selectedCategory);

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Hero Section */}
            <motion.section
                className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden"
                initial="hidden"
                animate="visible"
            >
                <div className="absolute inset-0">
                    <img
                        src="/images/IMG-20250605-WA0372.jpg"
                        alt="Ummeed Ki Kiran Foundation Media Gallery"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-purple-900/90 via-blue-800/80 to-indigo-900/90"></div>
                </div>

                <div className="relative z-10 max-w-6xl mx-auto px-4 text-center text-white">
                    <motion.div variants={staggerContainer}>
                        <motion.h1
                            className="text-6xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-white to-purple-200 bg-clip-text text-transparent"
                            variants={fadeInUp}
                        >
                            Our Journey Through Media
                        </motion.h1>
                        <motion.p
                            className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed"
                            variants={fadeInUp}
                        >
                            Explore our journey through photos, videos, and press coverage showcasing 8 years of impact in Varanasi
                        </motion.p>
                        <motion.div
                            className="flex flex-wrap justify-center gap-6"
                            variants={fadeInUp}
                        >
                            <div className="bg-white/20 backdrop-blur-md px-6 py-3 rounded-full border border-white/30 flex items-center gap-3">
                                <FaCamera className="text-purple-400 text-xl" />
                                <span className="font-semibold">Photo Gallery</span>
                            </div>
                            <div className="bg-white/20 backdrop-blur-md px-6 py-3 rounded-full border border-white/30 flex items-center gap-3">
                                <FaVideo className="text-blue-400 text-xl" />
                                <span className="font-semibold">Video Stories</span>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
            </motion.section>

            {/* Focus Areas Section */}
            <motion.section
                className="py-20 bg-white"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
            >
                <div className="max-w-7xl mx-auto px-4">
                    <motion.div className="text-center mb-16" variants={staggerContainer}>
                        <motion.h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" variants={fadeInUp}>
                            Media & Documentation
                        </motion.h2>
                        <motion.p className="text-xl text-gray-600" variants={fadeInUp}>
                            Capturing moments of transformation and sharing our impact stories
                        </motion.p>
                    </motion.div>

                    <motion.div
                        className="grid grid-cols-1 md:grid-cols-3 gap-8"
                        variants={staggerContainer}
                    >
                        <motion.div
                            className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-2xl text-center group"
                            variants={scaleIn}
                            whileHover={{ y: -10, scale: 1.02 }}
                            transition={{ duration: 0.3 }}
                        >
                            <div className="w-20 h-20 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl group-hover:scale-110 transition-transform">
                                <FaImage />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-800 mb-4">Photo Gallery</h3>
                            <p className="text-gray-600 leading-relaxed">
                                Capturing moments of transformation and hope in our educational programs and community activities
                            </p>
                        </motion.div>

                        <motion.div
                            className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl text-center group"
                            variants={scaleIn}
                            whileHover={{ y: -10, scale: 1.02 }}
                            transition={{ duration: 0.3 }}
                        >
                            <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl group-hover:scale-110 transition-transform">
                                <FaVideo />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-800 mb-4">Video Stories</h3>
                            <p className="text-gray-600 leading-relaxed">
                                Documentary coverage of our impact and success stories from the field with real testimonials
                            </p>
                        </motion.div>

                        <motion.div
                            className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-2xl text-center group"
                            variants={scaleIn}
                            whileHover={{ y: -10, scale: 1.02 }}
                            transition={{ duration: 0.3 }}
                        >
                            <div className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl group-hover:scale-110 transition-transform">
                                <FaNewspaper />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-800 mb-4">Press Coverage</h3>
                            <p className="text-gray-600 leading-relaxed">
                                Media recognition and news coverage of our community work and social impact initiatives
                            </p>
                        </motion.div>
                    </motion.div>
                </div>
            </motion.section>

            {/* Enhanced Navigation Tabs */}
            <motion.section
                className="py-12 bg-gradient-to-br from-gray-50 to-purple-50"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
            >
                <div className="max-w-4xl mx-auto px-4">
                    <motion.div
                        className="flex flex-wrap justify-center gap-4"
                        variants={staggerContainer}
                    >
                        <motion.button
                            className={`px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 flex items-center gap-3 ${activeTab === 'photos'
                                ? 'bg-purple-600 text-white shadow-lg'
                                : 'bg-white text-gray-600 hover:bg-purple-50 hover:text-purple-600'
                                }`}
                            onClick={() => setActiveTab('photos')}
                            variants={scaleIn}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <FaImage />
                            <span>Photo Gallery</span>
                        </motion.button>
                        <motion.button
                            className={`px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 flex items-center gap-3 ${activeTab === 'videos'
                                ? 'bg-blue-600 text-white shadow-lg'
                                : 'bg-white text-gray-600 hover:bg-blue-50 hover:text-blue-600'
                                }`}
                            onClick={() => setActiveTab('videos')}
                            variants={scaleIn}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <FaVideo />
                            <span>Videos</span>
                        </motion.button>
                        <motion.button
                            className={`px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 flex items-center gap-3 ${activeTab === 'news'
                                ? 'bg-green-600 text-white shadow-lg'
                                : 'bg-white text-gray-600 hover:bg-green-50 hover:text-green-600'
                                }`}
                            onClick={() => setActiveTab('news')}
                            variants={scaleIn}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <FaNewspaper />
                            <span>Press & News</span>
                        </motion.button>
                    </motion.div>
                </div>
            </motion.section>

            {/* Content Sections */}
            <AnimatePresence mode="wait">
                {/* Photo Gallery Tab */}
                {activeTab === 'photos' && (
                    <motion.section
                        className="py-20 bg-white"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.5 }}
                    >
                        <div className="max-w-7xl mx-auto px-4">
                            <motion.div className="text-center mb-12" variants={staggerContainer}>
                                <motion.h2 className="text-4xl font-bold text-gray-800 mb-6" variants={fadeInUp}>
                                    Photo Gallery
                                </motion.h2>
                                <motion.p className="text-xl text-gray-600" variants={fadeInUp}>
                                    Visual stories of our impact and community engagement
                                </motion.p>
                            </motion.div>

                            {/* Category Filter */}
                            <motion.div className="mb-12" variants={staggerContainer}>
                                <div className="flex flex-wrap justify-center gap-3">
                                    {categories.map((category) => (
                                        <motion.button
                                            key={category}
                                            className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${selectedCategory === category
                                                ? 'bg-purple-600 text-white shadow-lg'
                                                : 'bg-gray-100 text-gray-600 hover:bg-purple-50 hover:text-purple-600'
                                                }`}
                                            onClick={() => setSelectedCategory(category)}
                                            variants={scaleIn}
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.95 }}
                                        >
                                            {category}
                                        </motion.button>
                                    ))}
                                </div>
                            </motion.div>

                            {/* Photo Grid */}
                            <motion.div
                                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
                                variants={staggerContainer}
                                key={selectedCategory}
                            >
                                {filteredPhotos.map((photo) => (
                                    <motion.div
                                        key={photo.id}
                                        className="bg-white rounded-2xl shadow-lg overflow-hidden group"
                                        variants={slideInFromBottom}
                                        whileHover={{ y: -10, boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)" }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <div className="relative overflow-hidden">
                                            <img
                                                src={photo.image}
                                                alt={photo.title}
                                                className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                <div className="absolute bottom-4 left-4 right-4 text-white">
                                                    <div className="flex items-center justify-between">
                                                        <div className="flex items-center gap-4">
                                                            <div className="flex items-center gap-2">
                                                                <FaEye className="text-sm" />
                                                                <span className="text-sm">{photo.views}</span>
                                                            </div>
                                                            <div className="flex items-center gap-2">
                                                                <FaHeart className="text-sm" />
                                                                <span className="text-sm">{photo.likes}</span>
                                                            </div>
                                                        </div>
                                                        <FaShare className="text-sm cursor-pointer hover:scale-110 transition-transform" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="absolute top-4 right-4">
                                                <span className={`px-3 py-1 text-white text-sm font-medium rounded-full ${photo.category === 'Education' ? 'bg-blue-600' :
                                                    photo.category === 'Health' ? 'bg-red-600' :
                                                        photo.category === 'Training' ? 'bg-green-600' :
                                                            photo.category === 'Community' ? 'bg-purple-600' :
                                                                photo.category === 'Development' ? 'bg-indigo-600' :
                                                                    photo.category === 'Empowerment' ? 'bg-orange-600' :
                                                                        photo.category === 'Achievements' ? 'bg-pink-600' : 'bg-gray-600'
                                                    }`}>
                                                    {photo.category}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="p-6">
                                            <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-purple-600 transition-colors">
                                                {photo.title}
                                            </h3>
                                            <p className="text-gray-600 leading-relaxed">
                                                {photo.description}
                                            </p>
                                        </div>
                                    </motion.div>
                                ))}
                            </motion.div>
                        </div>
                    </motion.section>
                )}

                {/* Videos Tab */}
                {activeTab === 'videos' && (
                    <motion.section
                        className="py-20 bg-gray-50"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.5 }}
                    >
                        <div className="max-w-7xl mx-auto px-4">
                            <motion.div className="text-center mb-12" variants={staggerContainer}>
                                <motion.h2 className="text-4xl font-bold text-gray-800 mb-6" variants={fadeInUp}>
                                    Video Gallery
                                </motion.h2>
                                <motion.p className="text-xl text-gray-600" variants={fadeInUp}>
                                    Watch our impact stories and get an inside look at our programs
                                </motion.p>
                            </motion.div>

                            <motion.div
                                className="grid grid-cols-1 md:grid-cols-2 gap-8"
                                variants={staggerContainer}
                            >
                                {videos.map((video) => (
                                    <motion.div
                                        key={video.id}
                                        className="bg-white rounded-2xl shadow-lg overflow-hidden group"
                                        variants={slideInFromBottom}
                                        whileHover={{ y: -10, boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)" }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <div className="relative overflow-hidden">
                                            <img
                                                src={video.thumbnail}
                                                alt={video.title}
                                                className="w-full h-64 object-cover"
                                            />
                                            <div className="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                <motion.div
                                                    className="w-20 h-20 bg-white/90 rounded-full flex items-center justify-center cursor-pointer"
                                                    whileHover={{ scale: 1.1 }}
                                                    whileTap={{ scale: 0.9 }}
                                                >
                                                    <FaPlay className="text-blue-600 text-2xl ml-1" />
                                                </motion.div>
                                            </div>
                                            <div className="absolute bottom-4 right-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm">
                                                {video.duration}
                                            </div>
                                            <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm">
                                                {video.category}
                                            </div>
                                        </div>

                                        <div className="p-6">
                                            <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">
                                                {video.title}
                                            </h3>
                                            <p className="text-gray-600 leading-relaxed mb-4">
                                                {video.description}
                                            </p>
                                            <div className="flex items-center justify-between text-sm text-gray-500">
                                                <div className="flex items-center gap-4">
                                                    <div className="flex items-center gap-1">
                                                        <FaEye />
                                                        <span>{video.views} views</span>
                                                    </div>
                                                    <span>{video.uploadDate}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                ))}
                            </motion.div>
                        </div>
                    </motion.section>
                )}

                {/* News & Press Tab */}
                {activeTab === 'news' && (
                    <motion.section
                        className="py-20 bg-white"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.5 }}
                    >
                        <div className="max-w-7xl mx-auto px-4">
                            <motion.div className="text-center mb-12" variants={staggerContainer}>
                                <motion.h2 className="text-4xl font-bold text-gray-800 mb-6" variants={fadeInUp}>
                                    Press Coverage & News
                                </motion.h2>
                                <motion.p className="text-xl text-gray-600" variants={fadeInUp}>
                                    Our work featured in media and press releases
                                </motion.p>
                            </motion.div>

                            <motion.div
                                className="grid grid-cols-1 lg:grid-cols-2 gap-8"
                                variants={staggerContainer}
                            >
                                {mediaNews.map((news) => (
                                    <motion.article
                                        key={news.id}
                                        className={`bg-white rounded-2xl shadow-lg overflow-hidden group ${news.featured ? 'lg:col-span-2' : ''
                                            }`}
                                        variants={slideInFromBottom}
                                        whileHover={{ y: -10, boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)" }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <div className="p-8">
                                            <div className="flex items-center justify-between mb-4">
                                                <span className={`px-4 py-2 rounded-full text-sm font-medium ${news.featured ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'
                                                    }`}>
                                                    {news.type}
                                                </span>
                                                <div className="flex items-center gap-2 text-gray-500 text-sm">
                                                    <FaCalendar />
                                                    <span>{news.date}</span>
                                                </div>
                                            </div>

                                            <h3 className="text-2xl font-bold text-gray-800 mb-4 group-hover:text-green-600 transition-colors">
                                                {news.title}
                                            </h3>

                                            <p className="text-gray-600 mb-4 italic">
                                                Source: {news.source}
                                            </p>

                                            <p className="text-gray-600 leading-relaxed mb-6">
                                                {news.description}
                                            </p>

                                            <div className="flex items-center justify-between">
                                                <span className="text-sm text-gray-500">{news.readTime}</span>
                                                <motion.a
                                                    href={news.link}
                                                    className="inline-flex items-center gap-2 bg-green-600 text-white px-6 py-3 rounded-full font-medium hover:bg-green-700 transition-colors"
                                                    whileHover={{ scale: 1.05 }}
                                                    whileTap={{ scale: 0.95 }}
                                                >
                                                    Read More
                                                    <FaExternalLinkAlt className="text-sm" />
                                                </motion.a>
                                            </div>
                                        </div>
                                    </motion.article>
                                ))}
                            </motion.div>
                        </div>
                    </motion.section>
                )}
            </AnimatePresence>

            {/* Media Contact Section */}
            <motion.section
                className="py-20 bg-gradient-to-br from-gray-900 to-purple-900 text-white"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
            >
                <div className="max-w-7xl mx-auto px-4">
                    <motion.div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" variants={staggerContainer}>
                        <motion.div variants={fadeInLeft}>
                            <h3 className="text-4xl font-bold mb-6">Media Inquiries & Press Kit</h3>
                            <p className="text-xl mb-8 leading-relaxed">
                                For media inquiries, interviews, or high-resolution images, please contact us.
                                We're always happy to share our story and impact.
                            </p>
                            <div className="space-y-4">
                                <div className="flex items-center gap-3">
                                    <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                                        <FaCalendar className="text-purple-300" />
                                    </div>
                                    <div>
                                        <p className="font-semibold">Phone:</p>
                                        <p>+917985947303</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                                        <FaNewspaper className="text-purple-300" />
                                    </div>
                                    <div>
                                        <p className="font-semibold">Email:</p>
                                        <p>support@ummeedkikiran.org</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                                        <FaCamera className="text-purple-300" />
                                    </div>
                                    <div>
                                        <p className="font-semibold">Location:</p>
                                        <p>Varanasi, Uttar Pradesh</p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        <motion.div
                            className="bg-white/10 backdrop-blur-md rounded-2xl p-8"
                            variants={fadeInRight}
                        >
                            <h4 className="text-2xl font-bold mb-6">Download Press Kit</h4>
                            <p className="mb-8 leading-relaxed">
                                Get all the resources you need for media coverage including high-resolution images,
                                fact sheets, and detailed information about our programs.
                            </p>
                            <motion.button
                                className="bg-white text-purple-900 px-8 py-4 rounded-full font-semibold text-lg flex items-center gap-3 hover:bg-gray-100 transition-colors w-full justify-center"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                <FaDownload />
                                Download Press Kit
                            </motion.button>
                            <div className="mt-6 text-center">
                                <p className="text-sm opacity-75">
                                    <strong>Founded:</strong> 2016 | <strong>Registration:</strong> Indian Trust Act
                                </p>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
            </motion.section>
        </div>
    );
};

export default MediaPage;
// Note: You would typically put the CSS in a separate MediaPage.css file 